const seatsPostBookingUtils = require('../../../utils/postbooking/js/seats');
const postBookingUtils = require('../../../utils/postbooking/js/utils');

const CONST = {
    templateName: 'boxEnhanced',
    outboundFlightIconClass: 'odf-icon-flight-right',
    inboundFlightIconClass: 'odf-icon-flight-left',
    parentIcon: 'odf-support-seat',
    parentIconSize: 'odf-icon-svg-s',
    titleClasses: 'odf-text-2xl',
    ctaClasses: 'prisma-btn prisma-btn-highlight prisma-btn-block',
    informativeStatusBoxClasses: 'odf-msg-informative odf-strong',
    informativeStatusIconClasses: 'odf-icon-information',
    persuasiveMessageTextClasses: 'odf-text-md',
    productInfoTextClass: 'odf-text-md',

};

class UIStrategy {
    constructor(bookingInfo, view, templates, keys, constants = {}) {
        this.CONST = Odigeo._.merge({}, CONST, constants);
        this.view = view;
        this.templates = templates;
        this.keys = keys;
        this.bookingInfo = bookingInfo || {};
    }

    isProductAvailable() {
        return false;
    }

    getData() {
        return {
            template: {
                name: this.CONST.templateName,
            },
            isSelected: false,
            productAvailable: this.isProductAvailable(),
            parent: {
                base: {
                    icon: {
                        classes: [this.CONST.parentIcon, this.CONST.parentIconSize].join(' '),
                    },
                    title: {
                        text: this.keys.title,
                        classes: this.CONST.titleClasses,
                    },
                    additionalInfo: {
                        text: this.templates.infoBox(this.getAdditionalInfoData()),
                    },
                },
            },
            child: {
                hide: true,
                custom: {
                    toggleChildLayer: this.view.toggleChildLayer.bind(this.view),
                },
            },
        };
    }

    getAdditionalInfoData() {
        return {
            keys: this.keys,
            productInfoTextClass: this.CONST.productInfoTextClass,
            isRoundTrip: postBookingUtils.isRoundTrip(this.bookingInfo),
            inboundFlightIconClass: this.CONST.inboundFlightIconClass,
            outboundFlightIconClass: this.CONST.outboundFlightIconClass,
            seatsPerLeg: seatsPostBookingUtils.getSeatsInfoFromBookingInfo(this.bookingInfo),
        };
    }
}

module.exports = UIStrategy;
